var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCanceled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0703 5.00049C10.0703 7.76191 7.83174 10.0005 5.07031 10.0005C2.30889 10.0005 0.0703125 7.76191 0.0703125 5.00049C0.0703125 2.23906 2.30889 0.000488281 5.07031 0.000488281C7.83174 0.000488281 10.0703 2.23906 10.0703 5.00049Z",
    fill: "#951C19"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.07031 3.00049L7.07031 7.00049M3.07031 7.00049L7.07031 3.00049",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanceled);
export default __webpack_public_path__ + "static/media/canceled.b6bc8be1bdc61a585329b4e224f59d66.svg";
export { ForwardRef as ReactComponent };